module.exports = __webpack_public_path__ + "static/media/slytherin.59f8fcf5.png";